import { AUTH_ROUTES } from './auth-routes'
import { LANDING_PAGES_ROUTES } from './landing-pages-routes'
import { PUBLIC_MAIN_ROUTES } from './main-routes'

export { AUTH_ROUTES, LANDING_PAGES_ROUTES, PUBLIC_MAIN_ROUTES }

const ROUTES = { ...AUTH_ROUTES, ...LANDING_PAGES_ROUTES, ...PUBLIC_MAIN_ROUTES }
export default ROUTES
